import { AlgoliaSearchHelper, SearchClient } from 'lib/util/algolia';
import { Dispatch, SetStateAction } from 'react';
import type { NmdpAppProviderContextData, NmdpAppProviderContextState } from './types';

/**
 * Represents the context for the NmdpAppProvider, managing the state and interactions
 * with the search client. This class ensures that the search client is properly initialized
 * and provides methods to update and retrieve the search client state.
 *
 * @implements {NmdpAppProviderContextData}
 */
export class NmdpAppProviderContext implements NmdpAppProviderContextData {
  searchHelper: AlgoliaSearchHelper | null = null;
  setSearchHelper: Dispatch<SetStateAction<AlgoliaSearchHelper | null>>;

  constructor({ searchHelperTuple }: NmdpAppProviderContextState) {
    this.searchHelper = searchHelperTuple[0];
    this.setSearchHelper = searchHelperTuple[1];
  }

  updateStateInstances({ searchHelperTuple }: NmdpAppProviderContextState): void {
    this.searchHelper = searchHelperTuple[0];
    this.setSearchHelper = searchHelperTuple[1];
  }

  get initialized(): boolean {
    return !!this.searchHelper;
  }
  get searchClient(): SearchClient | null {
    const client = this.searchHelper?.getClient();
    return (client as SearchClient) ?? null;
  }
  get hasSearchClient(): boolean {
    return !!this.searchClient;
  }

  /*
  setSearchHelper(
    searchHelper:
      | AlgoliaSearchHelper
      | ((current: AlgoliaSearchHelper | null) => AlgoliaSearchHelper)
  ): void {
    if (!searchHelper) {
      throw new Error('searchClient cannot be null or undefined.');
    }
    if (!this.#setSearchHelperState) {
      throw new Error(
        'searchHelper state is not initialized - make sure your component is wrapped by an AlgoliaSearch component.'
      );
    }
    this.#setSearchHelperState(searchHelper);
  }
  */
}
